module.exports = {
    RECEIVE_ALL_NETWORKS: 'RECEIVE_ALL_NETWORKS',
    RECEIVE_NETWORK: 'RECEIVE_NETWORK',
    RESET_NETWORK: 'RESET_NETWORK',
}